var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankCardPattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 368,
    height: 209,
    viewBox: "0 0 368 209",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_53_25306",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 368,
    height: 209
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 368,
    height: 208.345,
    rx: 33.9692,
    fill: "#ED713C"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_53_25306)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 28.622,
    cy: 241.181,
    rx: 187.505,
    ry: 127.951,
    fill: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.08,
    cx: 339.376,
    cy: -32.8368,
    rx: 187.505,
    ry: 127.951,
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankCardPattern);
export default __webpack_public_path__ + "static/media/bank-card-pattern.4d686201f8e605a325f2d991941a62b0.svg";
export { ForwardRef as ReactComponent };